<template>
  <!--
    作者：kmdshop
    时间：2023-01-01
    描述：插件中心-股东分红
  -->
  <div>

    <!--商品设置-->
    <Mean v-if="activeName == 'mean'"></Mean>

    <!--商品设置-->
    <Contribution v-if="activeName == 'contribution'"></Contribution>

    <!--设置-->
    <Setting v-if="activeName == 'setting'"></Setting>

  </div>
</template>
<script>
import bus from '@/utils/eventBus.js';
import Mean from './mean/index';
import Contribution from './contribution/index';
import Setting from './setting/index';

export default {
  components: {
    Mean,
    Contribution,
    Setting
  },
  data() {
    return {
      /*参数*/
      param: {},
      /*当前选中*/
      activeName: 'mean',
      /*切换数组原始数据*/
      sourceList: [
        {
          key: 'mean',
          value: '平均分红',
          path:'/plus/partner/mean/index'
        },
        {
          key: 'contribution',
          value: '贡献值分红',
          path:'/plus/partner/contribution/index'
        },
        {
          key: 'setting',
          value: '基础设置',
          path:'/plus/partner/setting/index'
        }
      ],
      /*权限筛选后的数据*/
      tabList:[],
    };
  },
  created() {

    this.tabList=this.authFilter();

    if(this.tabList.length>0){
      this.activeName=this.tabList[0].key;
    }

    if (this.$route.query.type != null) {
      this.activeName = this.$route.query.type;
    }

    /*监听传插件的值*/
    bus.$on('activeValue', res => {
      this.activeName = res;
    });

    //发送类别切换
    let params = {
      active: this.activeName,
      list: this.tabList,
      tab_type: 'partner'
    };
    bus.$emit('tabData', params);
  },
  beforeDestroy() {
    //发送类别切换
    bus.$emit('tabData', { active: null, tab_type: 'partner', list: [] });
    bus.$off('activeValue');
  },
  methods: {

    /*权限过滤*/
    authFilter(){
      let list=[];
      for(let i=0;i<this.sourceList.length;i++){
        let item=this.sourceList[i];
        if(this.$filter.isAuth(item.path)){
          list.push(item);
        }
      }
      return list;
    },

  }
};
</script>



// WEBPACK FOOTER //
// src/views/plus/partner/index.vue